<template>
  <div class="vertical-timeline-item vertical-timeline-element">
    <div>
      <span class="vertical-timeline-element-icon bounce-in">
        <!-- <i class="badge badge-dot badge-dot-xl badge-success"></i> -->
        <i class="scf-picto-v2" :style="{ color: color }" />
      </span>
      <div class="vertical-timeline-element-content bounce-in">
        <b
          data-bs-toggle="collapse"
          :href="'#collapse-example-' + Id"
          aria-expanded="true"
          :aria-controls="'collapse-example-' + Id"
          id="maincard99-header99"
        >
          <h4 class="timeline-title" :style="{ color: color }">
            <!-- {{ SourceType }} -->
            {{
              
              !this.translationExists("pages.DeviceDetails.DeviceSources." + SourceType)
                ? SourceType
                : this.$t("pages.DeviceDetails.DeviceSources." + SourceType)
            }}
            {{
              Status == "KO"
                ? `(${this.$t("pages.DeviceDetails.TimeLine.Rejected")})`
                : ``
            }}
          </h4>
        </b>
        <div v-if="createUser">
          <span>{{ createUser }}</span>
        </div>
        
        <div
          :id="'collapse-example-' + Id"
          class="collapse show"
          aria-labelledby="maincard99-header99"
        >
          <!-- solid style of the question circle icon -->
          <div class="card-body">
            <div class="row">
              <ul class="element-item" style="list-style-type: none">
                <li>
                  <div style="cursor: pointer; color: blue" @click="download">
                    {{ actionSource }}
                  </div>
                </li>
                <li v-for="(item, index) in ErrorMessages" v-bind:key="index">
                  {{ ErrorMessages[index] }}
                </li>
                <li v-for="(item, index) in itemsFiltred" v-bind:key="index">
                  <b :style="{ color: color }">{{
                    ['TransmitterState', 'SensorState'].includes(item.parameterName)
                      ? this.$t(`pages.DeviceDetails.${item.parameterName}`)
                      : this.GetParameterTraductionTimeLine(item.parameterName)
                  }}</b>
                  {{
                    item.oldValue == null
                      ? this.$t("pages.DeviceDetails.TimeLine.SetTo")
                      : this.$t("pages.DeviceDetails.TimeLine.UpdatedFrom")
                  }}
                  <b
                    ><span
                      v-if="
                        item.parameterName == 'TransmitterState' ||
                        item.parameterName == 'SensorState'
                      "
                      >{{
                        this.GetLifeCycleTraductions(
                          item.oldValue == null ? GetParametersTraductionValue(item.newValue) : GetParametersTraductionValue(item.oldValue)
                        )
                      }}</span
                    ><span v-else>{{
                      item.oldValue == null ? GetParametersTraductionValue(item.newValue) : GetParametersTraductionValue(item.oldValue)
                    }}</span></b
                  >
                  <!-- <b>{{ item.oldValue != null ? item.oldValue : "" }}</b> -->
                  {{
                    item.oldValue != null
                      ? ` ${this.$t("pages.DeviceDetails.TimeLine.To")}`
                      : ""
                  }}
                  <b>{{
                    item.oldValue != null
                      ? item.newValue != null
                        ? item.parameterName == "TransmitterState" ||
                          item.parameterName == "SensorState"
                          ? this.GetLifeCycleTraductions(item.newValue)
                          : this.GetParametersTraductionValue(item.newValue)
                        : this.$t("pages.DeviceDetails.TimeLine.None")
                      : ""
                  }}</b>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span class="vertical-timeline-element-date">
          {{ formatDate(date) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import utils from "../Utils/libraries";
import Configs from "../../configs";
import MainService from "../services/MainService";
export default {
  name: "TimelineItem",
  inject: ["accessToken"],
  components: {},
  watch: {
    currentScope(newVal) {
      if (newVal) {
        this.mainService = new MainService(this.$jwt.token, newVal);
      }
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.$props.Scope);
      }
    },
    ErrorMessages: {
      handler: function (values) {
        values.forEach((element) => {
          console.log("errpr : ", element);
        });
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    createdUser: {
      type: String,
      default: null,
    },
    Id: {
      type: Number,
      required: false,
      default: 0,
    },
    Date: {
      type: String,
      required: false,
    },
    SourceType: {
      type: String,
      required: false,
      default: function () {
        return "Error";
      },
    },
    Source: {
      type: String,
      required: false,
    },
    DataModel: {
      type: Object,
      required: false,
    },
    Status: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      required: true,
    },
    ErrorMessages: {
      type: Array,
      default: null,
    },
    Scope: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: () => "black",
    },
    ImportId: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      itemsFiltred:[],
      deviceContentUrl: this.$props.ImportId != '00000000-0000-0000-0000-000000000000' ?
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/DeviceImports/deviceImportContent?deviceImportId=" +
        this.$props.ImportId : 
                Configs.value("VUE_APP_WEBAPI") +
        "api/v1/DeviceImports/deviceImportContentByExternalId?externalId=" +
        this.$props.Source,
      date: new Date(this.$props.Date),
      culture: computed(() => this.$i18n.locale),
      mainService: new MainService(this.$jwt.token, this.$props.Scope),
      //currentScope: this.$jwt.scope,
    };
  },
  methods: {
      sortItemsByParameterNameTranslation(items) {
    return items.sort((a, b) => {
        const nameA = this.GetParameterTraductionTimeLine(a.parameterName);
        const nameB = this.GetParameterTraductionTimeLine(b.parameterName);
        return nameA.localeCompare(nameB);
    });
},
    filterElementsBySource(source)
    {

   const exclusionMap = {
        Manufacturer: ["MeterModule2GIdentifier", "PulseWeightType","Version"],
        Assets: ["RadioTechnologyType"]
    };

    const exclusions = exclusionMap[source];

    if (!exclusions) {
        return this.items;
    }

    return this.items.filter(item => !exclusions.includes(item.parameterName));

    },
    GetLifeCycleTraductions(lifecycle) {
      let traduction = lifecycle;
      var x = this.DataModel.lifeCycle.states.filter(
        (e) => e.name == lifecycle
      );
      if (!utils.isEmpty(x)) {
        var traductions = x[0].translations;

        if (!utils.isEmpty(traductions)) {
          let trad;
          trad = traductions.filter((e) => e.culture == this.culture);
          if (!utils.isEmpty(trad)) {
            traduction = trad[0].value;
          }
        }
      }

      return traduction;
    },
    GetParameterTraductionTimeLine(value) {

      let obj = this.DataModel.deviceParameterDefinitions.filter(
        (e) => e.alternatifKey == value
      );
      if (!utils.isEmpty(obj)) {
        let tmp = this.items.filter((e) => e.parameterName == obj[0].key);
        //console.log("🚀 ~ file: Timeline.vue:217 ~ GetParameterTraductionTimeLine ~ tmp:", tmp);
        if (utils.isEmpty(tmp) || tmp[0].newValue == null) {
          let x = this.DataModel.deviceParameterDefinitions.filter(
            (e) => e.key == obj[0].key
          );
          if (!utils.isEmpty(x)) {
            let trad;

            if (!utils.isEmpty(x[0].translations)) {
              trad = x[0].translations.filter((e) => e.culture == this.culture);
              if (!utils.isEmpty(trad)) {
                return trad[0].value;
              } else {
                return value;
              }
            }
          }
        }
      }

      let x = this.DataModel.deviceParameterDefinitions.filter(
        (e) => e.key == value
      );

      if (!utils.isEmpty(x)) {
        let trad;

        if (!utils.isEmpty(x[0].translations)) {
          trad = x[0].translations.filter((e) => e.culture == this.culture);
          if (!utils.isEmpty(trad)) {
            return trad[0].value;
          } else {
            return x.key;
          }
        }
      }
      
      return !this.translationExists(this.$t("pages.DeviceDetails." + value))
        ? value
        : this.$t("pages.DeviceDetails." + value);
    },

    download() {
      if (this.isUserCreated) return;
      if (this.$props.SourceType == 'Manufacturer' && this.deviceContentUrl.includes('externalId')) this.deviceContentUrl += '&isCommonStock=true'; 
      this.mainService
        .Export(this.deviceContentUrl)
        .then((response) => {
          const type = response.headers["content-type"];
          utils.Download(this.$props.Source, type, response.data, false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
        GetParametersTraductionValue(value, key = null) {
        // console.log("🚀 ~ GetParametersTraductionValue ~ value:", value);

    
      if (utils.isObject(value)) {
        if   ( this.translationExists("pages.DeviceDetails.ParametersValues." + value.value))
          return this.$t("pages.DeviceDetails.ParametersValues." + value.value);
        else return value.value;
      } else {
        
        if (this.translationExists("pages.DeviceDetails.ParametersValues." + value))
          return this.$t("pages.DeviceDetails.ParametersValues." + value);
        if (key != null && key.toLowerCase().includes("date") && this.isDateValue(value)) {
          return this.$d(new Date(value).toISOString(), 'short');
        }
        
        return value;
      }
        
    },
    formatDate(date) {
      // console.log(date);
      // console.log(this.$i18n.locale);
      //
      const day = date.getDate(),
        month = date.getMonth() + 1;

      if (this.$i18n.locale == "fr-FR") {
        return `${day.length > 1 ? day : `${day}`}-${
          month.length < 1 ? month : `${month}`
        }-${date.getFullYear()} - ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} `;
      }
      return `${date.getFullYear()}-${day.length > 1 ? day : `${day}`}-${
        month.length > 1 ? month : `${month}`
      }- ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} `;
    },
    translationExists(e) {
      return typeof this.$tm(e) == "string";
    },
  },
  computed: {
    createUser(){
      return this.$props.SourceType ==="ReturnToCommunStock"? this.$props.createdUser : null;
    },
    actionSource() {
      if (this.$props.Source && this.$props.Source != "")
      
        return !this.translationExists("pages.DeviceDetails.DeviceSources." + this.$props.Source)
          ? this.$props.Source
          : this.$t("pages.DeviceDetails.DeviceSources." + this.$props.Source);
      return this.$props.createdUser;
    },
    isUserCreated() {
      return !(this.$props.Source && this.$props.Source != "");
    },
  },
      beforeMount() {
    
   // console.log("🚀 ~ beforeMount ~ target:", this.items, this.$props.SourceType);
   this.itemsFiltred =  this.filterElementsBySource(this.$props.SourceType);
   this.itemsFiltred = this.sortItemsByParameterNameTranslation(this.itemsFiltred);

   
  },
};
</script>

<style lang="scss" scoped>
.mt-70 {
  margin-top: 70px;
}

.mb-70 {
  margin-bottom: 70px;
}

.card-timeline {
  border-width: 0;
  transition: all 0.2s;
}

.card-timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}
.vertical-timeline {
  width: 100%;
  position: relative;
  padding: 1.5rem 0 1rem;
}

.vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 67px;
  height: 100%;
  width: 4px;
  background: #e9ecef;
  border-radius: 0.25rem;
}

.vertical-timeline-element {
  position: relative;
  margin: 0 0 1rem;
}

.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
  visibility: visible;
  animation: cd-bounce-1 0.8s;
}
.vertical-timeline-element-icon {
  position: absolute;
  top: 0;
  left: 60px;
}

.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}
.badge:empty {
  display: none;
}

.badge-dot-xl::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 0.25rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -5px 0 0 -5px;
  background: #fff;
}

.vertical-timeline-element-content {
  position: relative;
  margin-left: 90px;
  font-size: 0.8rem;
}

.vertical-timeline-element-content .timeline-title {
  font-size: 0.8rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  padding: 2px 0 0;
  font-weight: bold;
  font-family: D-DIN-700 !important;
}

.vertical-timeline-element-content .vertical-timeline-element-date {
  display: block;
  position: absolute;
  left: -155px;
  top: 0;
  padding-right: 10px;
  text-align: right;
  color: #adb5bd;
  font-size: 0.7619rem;
  white-space: nowrap;
}

.vertical-timeline-element-content:after {
  content: "";
  display: table;
  clear: both;
}

.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}
.badge-warning {
  color: #212529;
  background-color: #ffc107;
}
.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.title-col-card {
  font-family: D-DIN-700 !important;
  font-style: normal !important;
  color: #6095d6;
  // font-size: 15px !important;
}

.element-item {
  font-family: D-DIN !important;
  font-size: 13px !important;
}

.transmitterTitle {
  font-family: D-DIN !important;
  // font-style: normal !important;
  font-size: 12px;
}
</style>

<style lang="css">
@import "../../node_modules/@suez/custom-icons/suez-glyphicons.css";
@import "../../node_modules/bootstrap/dist/css/bootstrap.css";
</style>
